import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { authApi } from "api/authApi";
import { campaignsApi } from "api/companyApi";
import { referencesApi } from "api/referencesApi";
import authReducer from "../features/authSlice";
import companyReducer from "../features/companySlice";
import { persistStore, persistReducer } from "redux-persist";
import {
  accountsApi,
  userApi,
  exportsApi,
  feedbackApi,
  shareCampaignApi,
} from "../api";

const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["refreshToken", "accessToken", "isAuthenticated"],
};

export const store = configureStore({
  reducer: combineReducers({
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [campaignsApi.reducerPath]: campaignsApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [referencesApi.reducerPath]: referencesApi.reducer,
    [exportsApi.reducerPath]: exportsApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [shareCampaignApi.reducerPath]: shareCampaignApi.reducer,
    auth: persistReducer(persistConfig, authReducer),
    company: companyReducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      authApi.middleware,
      userApi.middleware,
      campaignsApi.middleware,
      accountsApi.middleware,
      exportsApi.middleware,
      referencesApi.middleware,
      feedbackApi.middleware,
      shareCampaignApi.middleware,
    ),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
